export class CustomerMargin {
  Counterparty?: string;
  MarketAccount?: string;
  Symbol?: string;
  Amount?: string;
  MarkPrice?: string;
  UnrealizedPnL?: string;
  BuyLockedMargin?: string;
  SellLockedMargin?: string;
  Collateral?: string;
  MarginCurrency?: string;
  StressFactor?: string;
  NegativeStressPnL?: string;
  PositiveStressPnL?: string;

  get rowID() {
    return ['CustomerMargin', this.Counterparty, this.MarketAccount, this.MarginCurrency, this.Symbol]
      .filter(Boolean)
      .join(':');
  }

  get counterpartyType() {
    return 'Customers';
  }

  constructor(data: Partial<CustomerMargin>) {
    Object.assign(this, data);
  }
}
